var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDiamond(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 386,
    viewBox: "0 0 347 386",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6422_4031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.549 289.512L173.516 289.529V289.545H173.5V289.48L173.516 289.496L173.549 289.512Z",
    fill: "#CD1D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.266 337.732H260.234L260.185 337.781L173.5 386V317.601H174.088C187.635 317.601 200.659 315.444 212.884 311.457C212.917 311.457 212.95 311.441 212.982 311.424L260.234 337.715H260.266V337.732Z",
    fill: "#CD1D65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5 317.601V386L94.3559 341.964V333.5L134.475 311.195C134.475 311.195 134.54 311.212 134.573 311.212C146.83 315.297 159.904 317.535 173.5 317.601Z",
    fill: "#BF212E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5 289.48V289.529L173.467 289.512L173.5 289.48Z",
    fill: "#BF212E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7663 144.74V144.805H86.75V144.789L86.701 144.772L86.75 144.74H86.7663Z",
    fill: "#C157A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7663 48.252V102.534H86.75C77.8383 111.226 70.2161 121.227 64.1934 132.24L0 96.5204L86.75 48.2684L86.7663 48.252Z",
    fill: "#C157A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1934 132.24C58.8072 142.093 54.7104 152.763 52.1153 164.005C52.1153 164.037 52.099 164.07 52.099 164.103L0.440687 192.845L0.0652869 193.024L0 193.057V96.5204L64.1934 132.24Z",
    fill: "#A61D4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.25 48.252L214.533 73.6934C201.851 69.347 188.239 66.994 174.088 66.994C173.892 66.994 173.696 66.994 173.5 67.0104V0L173.924 0.21242L260.25 48.252Z",
    fill: "#F7C5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5 0V67.0104C159.284 67.0594 145.639 69.4941 132.924 73.9385L86.7663 48.2684L173.5 0Z",
    fill: "#D01C66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8153 144.772L86.7663 144.789V144.805H86.75V144.74H86.7663L86.8153 144.772Z",
    fill: "#A61D4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.924 73.9385C115.444 80.017 99.7421 89.87 86.7663 102.534H86.75V48.252H86.7663L132.924 73.9385Z",
    fill: "#A61D4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.266 144.756V144.805H260.25V144.789H260.234L260.201 144.756L260.234 144.74H260.25L260.266 144.756Z",
    fill: "#EC2349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.266 48.2684V101.422C260.266 101.422 260.266 101.406 260.25 101.406C247.323 89.1184 231.785 79.5758 214.533 73.6934L260.25 48.2684H260.266Z",
    fill: "#EC2349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.108 153.792L173.924 192.845L173.565 193.025H173.549L173.516 193.057H173.5V112.517C173.712 112.501 173.941 112.501 174.153 112.501C204.234 112.501 230.43 129.135 244.059 153.727C244.075 153.743 244.091 153.759 244.108 153.792Z",
    fill: "#EC2349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.25 144.789V144.805L260.234 144.821V144.789H260.25Z",
    fill: "#EC2349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5 112.517V193.057L173.451 193.025L103.904 154.348C103.904 154.348 103.937 154.299 103.953 154.282C117.386 129.56 143.468 112.746 173.5 112.517Z",
    fill: "#AA204E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8153 144.772L86.7663 144.789V144.805H86.75V144.74H86.7663L86.8153 144.772Z",
    fill: "#BF212E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5 192.975V193.008H173.451L104.377 231.456C97.9304 219.92 94.258 206.636 94.258 192.485C94.258 178.335 97.7508 165.671 103.904 154.348C103.92 154.315 103.937 154.299 103.953 154.282L173.5 192.975Z",
    fill: "#BF212E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.099 164.103C50.0098 173.171 48.9162 182.6 48.9162 192.289C48.9162 199.544 50.0751 213.564 50.0751 213.564V220.852L0.0652869 193.025L0 192.992L52.1153 164.005C52.1153 164.005 52.099 164.07 52.099 164.103Z",
    fill: "#EF3E73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.75 144.74V144.789L86.701 144.772L86.75 144.74Z",
    fill: "#EF3E73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0751 220.852V261.685L0 289.545V192.992L0.0652869 193.025L50.0751 220.852Z",
    fill: "#F7C5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.516 289.496V289.545H173.5V289.529L173.467 289.512L173.5 289.48L173.516 289.496Z",
    fill: "#F7C5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.516 192.992V272.47H173.5C143.778 272.241 117.925 255.754 104.377 231.456L173.451 193.025H173.5V192.992H173.516Z",
    fill: "#F7C5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8153 337.764L86.75 337.797V337.732L86.8153 337.764Z",
    fill: "#EF3E73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.573 311.212L94.3559 333.598V288.891C106.124 298.63 119.687 306.261 134.475 311.195C134.507 311.212 134.54 311.212 134.573 311.212Z",
    fill: "#EF3E73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0751 261.685V317.405L0 289.545L50.0751 261.685Z",
    fill: "#EC2349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.299 144.772L260.266 144.789V144.805H260.25V144.74L260.266 144.756L260.299 144.772Z",
    fill: "#EF486E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.984 96.5204L283.704 131.749C277.469 120.459 269.537 110.23 260.266 101.422C260.266 101.422 260.266 101.406 260.25 101.406V48.2684H260.266L346.984 96.5204Z",
    fill: "#EF486E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.984 96.5368V193.057L346.935 193.025L296.239 164.822C296.239 164.822 296.223 164.773 296.223 164.74C293.595 153.041 289.352 141.962 283.704 131.749L346.984 96.5368Z",
    fill: "#F37772"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.299 144.772L260.266 144.789V144.805H260.25L260.234 144.821V144.74H260.25L260.266 144.756L260.299 144.772Z",
    fill: "#BF212E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 192.992H346.984L346.935 193.025L295.848 221.44C298.084 212.093 299.259 202.322 299.259 192.289C299.259 182.861 298.214 173.662 296.239 164.822C296.239 164.789 296.223 164.773 296.223 164.74L346.984 192.975H347V192.992Z",
    fill: "#BF212E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.064 192.485C254.064 206.864 250.277 220.361 243.634 232.028L173.565 193.025H173.516V192.992L244.059 153.727C244.059 153.727 244.091 153.759 244.108 153.792C250.457 165.246 254.064 178.449 254.064 192.485Z",
    fill: "#EF486E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.234 144.74V144.789L260.201 144.756L260.234 144.74Z",
    fill: "#EF486E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.549 289.512L173.516 289.529V289.545H173.5V289.48L173.516 289.496L173.549 289.512Z",
    fill: "#C157A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.634 232.028C229.892 256.195 203.924 272.486 174.153 272.486C173.941 272.486 173.728 272.486 173.516 272.47H173.5V192.992H173.516L173.549 193.025H173.565L243.634 232.028Z",
    fill: "#C157A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 192.992V289.545L283.068 253.973C288.764 243.924 293.106 233.009 295.848 221.456L346.935 193.025H346.984L347 192.992Z",
    fill: "#ED2232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 289.545L260.674 337.585L260.234 337.797V283.205C269.211 274.676 276.914 264.839 283.068 253.973L347 289.545Z",
    fill: "#C157A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.234 283.205V337.797H260.185L212.884 311.457C212.917 311.457 212.95 311.441 212.982 311.424C230.838 305.591 246.931 295.852 260.234 283.205Z",
    fill: "#A61D4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6422_4031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 347,
    height: 386,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.b483ad2b.svg";
export { ForwardRef as ReactComponent };